import Vue from "vue";
import Vuex from "vuex";
import concepts from "../../models/conceptos/concepts";
import salaryConcept from "../../models/conceptos/cSueldos";
import service from "../../services/conceptosDeSueldos/salaryConcepts";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    service: new service(),
    paddingNav: "10px",
    salariesConcepts: [],
    liquidations: [],
    salaries: [],
    open: false,
    mode: "Agregar concepto de sueldo",
    new: {},
    edit: {},
    itemDelete: null,
    openDelete: false,
    modeRelation: "Agregar concepto",
    editRelation: {},
    openRelation: false,
    openDeleteRelation: false,
  },

  mutations: {
    setPaddingNav(state, data) {
      state.paddingNav = data;
    },
    setSalariesConcepts(state, data) {
      state.salariesConcepts = data;
    },
    setOpen(state, data) {
      state.open = data;
    },
    setMode(state, data) {
      state.mode = data;
    },
    setNew(state, data) {
      state.new = data;
    },
    setEdit(state, data) {
      state.edit = data;
    },
    setOpenDelete(state, data) {
      state.openDelete = data;
    },
    setItemDelete(state, data) {
      state.itemDelete = data;
    },
    setModeRelation(state, data) {
      state.modeRelation = data;
    },
    setEditRelation(state, data) {
      state.editRelation = data;
    },
    setOpenRelation(state, data) {
      state.openRelation = data;
    },
    setOpenDeleteRelation(state, data) {
      state.openDeleteRelation = data;
    },
  },
  actions: {
    async getSaleriesConcepts(state) {
      return new Promise(async (resolve, reject) => {
        try {
          let items = await state.state.service.getSalarieConcepts();
          state.commit("setSalariesConcepts", items);
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },

    async getSalaryConceptId({ state, commit }, conceptoId) {
      try {
        const data = await state.service.getSalaryConceptId(conceptoId);
        commit("setEditRelation", data);
        return true;
      } catch (error) {
        throw error;
      }
    },

    async addSalaryConcept(state) {
      try {
        const response = await state.state.service.addSalaryConcept(
          state.state.new
        );
        const newItem = salaryConcept.fromJson(response.data);
        const updatedConcepts = [newItem, ...state.state.salariesConcepts];
        state.commit("setSalariesConcepts", updatedConcepts);
        return true;
      } catch (error) {
        return false;
      }
    },

    async deleteSalaryConcept(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service
            .deleteSalaryConcept(state.state.itemDelete)
            .then(() => {
              let options = state.state.salariesConcepts;
              options = options.filter((option) => {
                return option.id != state.state.itemDelete;
              });
              state.commit("setSalariesConcepts", options);
              resolve(true);
            });
        } catch (error) {
          reject(error);
        }
      });
    },

    async editSalaryConcept(state) {
      try {
        const response = await state.state.service.editSalaryConcept(
          state.state.edit
        );
        if (response.status === 204) {
          let item = state.state.edit;
          let options = state.state.salariesConcepts;
          if (options) {
            options = options.map((option) => {
              if (option.id !== item.csueldoid) {
                return option;
              } else {
                return {
                  ...option,
                  name: item.name,
                  intCod: Number(item.sueldosIntCod),
                  strCod: item.sueldosStrCod,
                };
              }
            });
          }

          state.commit("setSalariesConcepts", options);

          return true;
        } else {
          return false;
        }
      } catch (error) {
        throw error;
      }
    },
    async addConceptToSalary(state) {
      try {
        const response = await state.state.service.addConceptToSalary(
          state.state.new
        );
        const newItem = response.data;
        newItem.nombre = state.state.new.nombre;
        state.state.editRelation.conceptos.push(newItem);
        state.commit("setEditRelation", state.state.editRelation);
        return true;
      } catch (error) {
        throw error;
      }
    },
    editConceptToSalary(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service
            .editConceptToSalary(state.state.edit)
            .then(() => {
              let item = state.state.edit;
              let options = state.state.editRelation.conceptos;
              options = options.map((option) => {
                if (option.conceptoId !== Number(item.conceptoId)) {
                  return option;
                }
                item = {
                  fecDesde: item.itemsForm.dateStartInput,
                  fecHasta: item.itemsForm.dateEndInput,
                  conceptoId: item.conceptoId,
                  nombre: item.nombre,
                };
                return item;
              });

              let edit = { ...state.state.editRelation };
              edit.conceptos = options;

              state.commit("setEditRelation", edit);
              resolve(true);
            });
        } catch (error) {
          reject(error);
        }
      });
    },
    deleteConceptToSalary(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service
            .deleteConceptToSalary(state.state.itemDelete)
            .then(() => {
              let options = state.state.editRelation;

              options.conceptos = options.conceptos.filter((option) => {
                return option.conceptoId != state.state.itemDelete.conceptoId;
              });
              state.commit("setEditRelation", options);
              resolve(true);
            });
        } catch (error) {
          reject(error);
        }
      });
    },
  },
});
